export default __webpack_public_path__ + "assets/066fea30fa8183eb02be2b823cfd54e7.jpg";